import React, { useEffect, useState } from 'react';
import { TrashIcon } from 'lucide-react';
export function RuleConditionNode({
  condition,
  onChange,
  onRemove
}) {
  const [fieldOptions] = useState([{
    id: 'User',
    name: 'User'
  }, {
    id: 'Role',
    name: 'Role'
  }, {
    id: 'Value',
    name: 'Value'
  }, {
    id: 'GL Code',
    name: 'GL Code'
  }, {
    id: 'Vendor',
    name: 'Vendor'
  }, {
    id: 'Vendor Status',
    name: 'Vendor Status'
  }, {
    id: 'Entity',
    name: 'Entity'
  }, {
    id: 'Site',
    name: 'Site'
  }, {
    id: 'Delegation',
    name: 'Delegation'
  }, {
    id: 'Country',
    name: 'Country'
  }, {
    id: 'Tenant',
    name: 'Tenant'
  }]);
  const [operatorOptions, setOperatorOptions] = useState([{
    id: 'equals',
    name: 'Equals'
  }, {
    id: 'notEquals',
    name: 'Not Equals'
  }, {
    id: 'in',
    name: 'In'
  }, {
    id: 'notIn',
    name: 'Not In'
  }, {
    id: 'contains',
    name: 'Contains'
  }, {
    id: 'startsWith',
    name: 'Starts With'
  }, {
    id: 'endsWith',
    name: 'Ends With'
  }]);
  // Sample data for dropdowns based on field type
  const [fieldValues, setFieldValues] = useState({
    User: [{
      id: 'user-001',
      name: 'John Smith'
    }, {
      id: 'user-002',
      name: 'Jane Doe'
    }, {
      id: 'user-003',
      name: 'Michael Johnson'
    }],
    Role: [{
      id: 'role-001',
      name: 'Administrator'
    }, {
      id: 'role-002',
      name: 'Finance Manager'
    }, {
      id: 'role-003',
      name: 'Procurement Officer'
    }],
    Vendor: [{
      id: 'vendor-001',
      name: 'Office Depot'
    }, {
      id: 'vendor-002',
      name: 'Dell Technologies'
    }, {
      id: 'vendor-003',
      name: 'PrintWorks Inc.'
    }],
    'Vendor Status': [{
      id: 'New',
      name: 'New'
    }, {
      id: 'Active',
      name: 'Active'
    }, {
      id: 'Inactive',
      name: 'Inactive'
    }, {
      id: 'Blocked',
      name: 'Blocked'
    }],
    Entity: [{
      id: 'entity-001',
      name: 'Global Technologies Inc.'
    }, {
      id: 'entity-002',
      name: 'European Operations Ltd'
    }],
    Site: [{
      id: 'site-001',
      name: 'New York HQ'
    }, {
      id: 'site-002',
      name: 'San Francisco Office'
    }, {
      id: 'site-003',
      name: 'London Office'
    }],
    'GL Code': [{
      id: '1000.1100.1110',
      name: 'Cash and Cash Equivalents'
    }, {
      id: '5000.5200',
      name: 'Travel Expenses'
    }, {
      id: '4000',
      name: 'Revenue'
    }],
    Country: [{
      id: 'US',
      name: 'United States'
    }, {
      id: 'GB',
      name: 'United Kingdom'
    }, {
      id: 'CA',
      name: 'Canada'
    }, {
      id: 'DE',
      name: 'Germany'
    }, {
      id: 'FR',
      name: 'France'
    }, {
      id: 'JP',
      name: 'Japan'
    }, {
      id: 'CN',
      name: 'China'
    }, {
      id: 'RU',
      name: 'Russia'
    }, {
      id: 'IR',
      name: 'Iran'
    }, {
      id: 'KP',
      name: 'North Korea'
    }, {
      id: 'SY',
      name: 'Syria'
    }],
    Delegation: [{
      id: 'del-001',
      name: 'Finance Approval - Level 1'
    }, {
      id: 'del-002',
      name: 'Finance Approval - Level 2'
    }, {
      id: 'del-003',
      name: 'Procurement Approval'
    }],
    Tenant: [{
      id: 'tenant-001',
      name: 'Main Organization'
    }, {
      id: 'tenant-002',
      name: 'Subsidiary A'
    }, {
      id: 'tenant-003',
      name: 'Subsidiary B'
    }]
  });
  // Update operator options based on field
  useEffect(() => {
    if (condition.field === 'Value') {
      setOperatorOptions([{
        id: 'equals',
        name: 'Equals'
      }, {
        id: 'notEquals',
        name: 'Not Equals'
      }, {
        id: 'greaterThan',
        name: 'Greater Than'
      }, {
        id: 'greaterThanOrEqual',
        name: 'Greater Than or Equal'
      }, {
        id: 'lessThan',
        name: 'Less Than'
      }, {
        id: 'lessThanOrEqual',
        name: 'Less Than or Equal'
      }, {
        id: 'between',
        name: 'Between'
      }]);
    } else {
      setOperatorOptions([{
        id: 'equals',
        name: 'Equals'
      }, {
        id: 'notEquals',
        name: 'Not Equals'
      }, {
        id: 'in',
        name: 'In'
      }, {
        id: 'notIn',
        name: 'Not In'
      }, {
        id: 'contains',
        name: 'Contains'
      }, {
        id: 'startsWith',
        name: 'Starts With'
      }, {
        id: 'endsWith',
        name: 'Ends With'
      }]);
    }
  }, [condition.field]);
  const handleFieldChange = e => {
    const field = e.target.value;
    onChange({
      field,
      value: '',
      operator: field === 'Value' ? 'greaterThan' : 'equals' // Default operator based on field
    });
  };
  const handleOperatorChange = e => {
    onChange({
      operator: e.target.value
    });
  };
  const handleValueChange = e => {
    onChange({
      value: e.target.value
    });
  };
  const handleMultiValueChange = e => {
    // For multi-select (when operator is 'in' or 'notIn')
    const options = e.target.options;
    const selectedValues = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedValues.push(options[i].value);
      }
    }
    onChange({
      value: selectedValues
    });
  };
  // Determine if this is a multi-value field
  const isMultiValue = ['in', 'notIn'].includes(condition.operator);
  // Determine if this is a numeric field
  const isNumericField = condition.field === 'Value';
  // Determine if this is a dropdown field
  const isDropdownField = condition.field && condition.field !== 'Value';
  return <div className="p-4 bg-white border-b border-gray-200" data-id="element-11653">
      <div className="flex items-start" data-id="element-11654">
        <div className="flex-grow grid grid-cols-12 gap-3" data-id="element-11655">
          <div className="col-span-3" data-id="element-11656">
            <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-11657">
              Field
            </label>
            <select value={condition.field || ''} onChange={handleFieldChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-11658">
              <option value="" data-id="element-11659">Select Field</option>
              {fieldOptions.map(option => <option key={option.id} value={option.id} data-id="element-11660">
                  {option.name}
                </option>)}
            </select>
          </div>
          <div className="col-span-3" data-id="element-11661">
            <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-11662">
              Operator
            </label>
            <select value={condition.operator || ''} onChange={handleOperatorChange} disabled={!condition.field} className={`shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md ${!condition.field ? 'bg-gray-50' : ''}`} data-id="element-11663">
              <option value="" data-id="element-11664">Select Operator</option>
              {operatorOptions.map(option => <option key={option.id} value={option.id} data-id="element-11665">
                  {option.name}
                </option>)}
            </select>
          </div>
          <div className="col-span-5" data-id="element-11666">
            <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-11667">
              Value
            </label>
            {isDropdownField && (isMultiValue ? <select multiple value={Array.isArray(condition.value) ? condition.value : []} onChange={handleMultiValueChange} disabled={!condition.operator} className={`shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md ${!condition.operator ? 'bg-gray-50' : ''}`} size={4} data-id="element-11668">
                  {fieldValues[condition.field]?.map(option => <option key={option.id} value={option.id} data-id="element-11669">
                      {option.name}
                    </option>)}
                </select> : <select value={condition.value || ''} onChange={handleValueChange} disabled={!condition.operator} className={`shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md ${!condition.operator ? 'bg-gray-50' : ''}`} data-id="element-11670">
                  <option value="" data-id="element-11671">Select Value</option>
                  {fieldValues[condition.field]?.map(option => <option key={option.id} value={option.id} data-id="element-11672">
                      {option.name}
                    </option>)}
                </select>)}
            {isNumericField && <input type="number" value={condition.value || ''} onChange={handleValueChange} disabled={!condition.operator} className={`shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md ${!condition.operator ? 'bg-gray-50' : ''}`} placeholder="Enter numeric value" data-id="element-11673" />}
            {!isDropdownField && !isNumericField && <input type="text" value={condition.value || ''} onChange={handleValueChange} disabled={!condition.operator} className={`shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md ${!condition.operator ? 'bg-gray-50' : ''}`} placeholder="Enter value" data-id="element-11674" />}
          </div>
        </div>
        <div className="ml-3 flex-shrink-0" data-id="element-11675">
          <button type="button" onClick={onRemove} className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-11676">
            <TrashIcon className="h-4 w-4" data-id="element-11677" />
          </button>
        </div>
      </div>
    </div>;
}